import React from 'react';
import { styled } from '@erecruit/ui-kit';
import { Resources } from '@erecruit/types';
import { PositionField } from '../types';

import { WizardStep } from '../../../App/components/RoutedWizard';
import GeneralStep from './GeneralStep';
import { LocationStep } from './LocationStep';
import { ScheduleStep } from './ScheduleStep';
import { BillingStep } from './BillingStep';
import { ReviewStep } from './ReviewStep';
import { AdditionalInfoStep } from './AdditionalInfoStep';

const Container = styled.div`
  padding: 0 101px;
`;

export const getWizardSteps = (
  positionTemplateId: number,
  fields: PositionField[],
  customFields: Resources.CustomField[],
): WizardStep[] => [
  ...[
    {
      title: 'General',
      name: 'general',
      route: '/wizard/general',
      content: () => (
        <Container>
          <GeneralStep fields={fields} />
        </Container>
      ),
    },
    {
      title: 'Location',
      name: 'location',
      route: '/wizard/location',
      content: () => (
        <Container>
          <LocationStep fields={fields} />
        </Container>
      ),
    },
    {
      title: 'Schedule',
      name: 'schedule',
      route: '/wizard/schedule',
      content: () => (
        <Container>
          <ScheduleStep fields={fields} />
        </Container>
      ),
    },
    {
      title: 'Billing',
      name: 'billing',
      route: '/wizard/billing',
      content: () => (
        <Container>
          <BillingStep
            positionTemplateId={positionTemplateId}
            fields={fields}
          />
        </Container>
      ),
    },
  ],
  ...(customFields.length > 0
    ? [
        {
          title: 'Additional Info',
          name: 'additionalInfo',
          route: '/wizard/additionalInfo',
          content: () => (
            <Container>
              <AdditionalInfoStep fields={customFields} showHeader={true} />
            </Container>
          ),
        },
      ]
    : []),
  {
    title: 'Review',
    name: 'review',
    route: '/wizard/review',
    content: () => (
      <Container>
        <ReviewStep fields={fields} />
      </Container>
    ),
  },
];
